import { Products } from '@/helpers/product'

export function nextGenerationsPlan(planName: string | null | undefined): number {
  return planName?.toLowerCase() === 'pro' ? Products.Premium : Products.Pro
}

export function formatMonthlyResetDate(): string {
  const now = new Date()

  return new Date(now.getFullYear(), now.getMonth() + 1, 1).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
  })
}
